export { SentryMonitoringService } from './services/sentry-monitoring.service';

// Re-export Sentry webpack plugin for Next.js config
export { withSentryConfig } from '@sentry/nextjs';

// Export initialization functions for Sentry client and server
export { initializeSentryBrowserClient } from './sentry.client.config';
export { initializeSentryServerClient } from './sentry.server.config';
